class Screen {

    constructor(model, persistance, parent) {

        this.element = null;
        this.model = model;
        this.index = -1;
        this.current = null;
        this.persistance = persistance;
        this.parent = parent || null;
        this.behaviorsAdaptive = null;
        this.waterMark = null;
        this.returnModal = null;
        this.fixSize = null;
        
        

        this.level = this.isRoot() ? 0 : this.parent.level + 1;
        this.uid = this.isRoot() ? "ROOT" : model.uid;

        if (this.isCollection()) {
            let models = model.pages.concat([]);

            // if (this.hasBehaviors()) {
                
            //     if (this.needToShuffle()) {
            //         models = this.shuffleThe(models);
            //     }

            //     if (this.needToPickASample()) {

            //         if (this.model.behaviors.sample < models.length) {

            //             models = this.pickTheSampleOf(this.model.behaviors.sample, models);
            //         }


            //     }
            // }
            this.pages = models.map(m => new Screen(m, persistance, this));
            this.current = this.pages[0];
        }

        
    }

    isRoot() {
        return this.parent === null;
    }

    get shuffleKey() {
        return "s";
    }

    get pagesModel(){
        return this.model;
    }

    shuffleThe(models) {
        let shuffledIMap = this.loadData(this.shuffleKey) || shuffle(this.makeIndexMap(models.length));
        this.saveData(this.shuffleKey, shuffledIMap);
        return mapModel(shuffledIMap, models);
    }

    makeIndexMap(length) {
        var indexMap = [];
        for (let index = 0; index < length; index++) {
            indexMap.push(index);
        }
        return indexMap;
    }


    saveData(key, value) {
        let data = this.persistance.loadObject(this.uid) || {};
        data[key] = value;
        this.persistance.saveObject(this.uid, data);
    }

    loadData(key) {
        let data = this.persistance.loadObject(this.uid) || {};
        return data[key];
    }

    pickTheSampleOf(sample, models) {
        return models.splice(0, sample);
    }

    needToShuffle() {
        let need = this.model.behaviors.hasOwnProperty("shuffle");
        return need;
    }

    needToPickASample() {
        let need = this.model.behaviors.hasOwnProperty("sample");
        return need;
    }

    hasBehaviors() {
        let has = this.model.hasOwnProperty("behaviors");
        return has;
    }

    render() {
        if (this.element == null) {
            this.element = document.createElement("iframe");
            this.element.id = this.model.uid;

            if (this.element.src != path(this.model.src)) {
                this.element.src = path(this.model.src);
            }
        }

    }

    first() {
        this.index = this.minLimit();
        this.current = this.pages[this.minLimit()];
        
        return this.current;
    }

    last() {
        this.index = this.maxLimit();
        this.current = this.pages[this.maxLimit()];
        return this.current;
    }

    selectPage(uid) {
        if (this.isSimpleScreen()) return null;
        var pageToReturn = null;
        let index_found = this.getIndex(uid);
        if (index_found > -1) {
            pageToReturn = this.goto(index_found);
            if (pageToReturn.isCollection()) {
                pageToReturn = pageToReturn.selectPage(pageToReturn.getCurrentScreen().uid);
            }
        } else {
            pageToReturn = this.pages.reduce((last, current, index) => {
                if (last == null) {
                    if (current.model.uid == uid) {
                        return current;
                    } else {
                        this.goto(index);
                        return current.selectPage(uid);
                    }
                }
                return last;
            }, null);
        }
        return this.pageToReturnCondition(pageToReturn);
    }

    pageToReturnCondition(pageToReturn) {
        if (this.isRoot() && (pageToReturn == null || pageToReturn == undefined)) {
            return this.first();
        }
        return pageToReturn;
    }
    
    getIndex(uid) {
        let index = -1;
        if (this.isCollection() && typeof uid == 'string') {
            index = this.pages.findIndex(p => p.model.uid == uid);
        }
        return index;
    }

    getCurrentScreen() {
        if (this.isSimpleScreen()) return this;
        return this.current.getCurrentScreen();
    }

    loadPageEvents(screen) {
        screen.element.contentWindow.events = new EventEmitter();

        screen.element.contentWindow.onready = function() {
            screen.element.contentWindow.events.emit('ready');
        }

        screen.element.contentWindow.enterView = function(direction) {
            screen.element.contentWindow.events.emit('enterView', {
                direction: direction
            });
        }

        screen.element.contentWindow.exitView = function(direction) {
            screen.element.contentWindow.events.emit('exitView', {
                direction: direction
            });
        }
    }

    walkFix(direction) {
        if (direction < 0) {
            this.index = this.maxLimit() + 1;
        } else
        if (direction > 0) {
            this.index = this.minLimit() - 1;
        }
    }

    walk(direction) {
        let nextScreen = null;
        if (this.current.isCollection()) {
            nextScreen = this.current.walk(direction);
        } else {
            var nextIndex = this.index + direction;
            let next = this.goto(nextIndex);
            nextScreen = next;
            if (this.indexIsOutLimits(nextIndex)) {
                this.index = nextIndex;
                this.indexClampLimit();
                return null;
            } else if (next.isCollection()) {
                next.walkFix(direction);
                nextScreen = next.walk(direction);
            }
        }
        if (nextScreen == null) {
            nextScreen = this.goto(this.index + direction);
            if (nextScreen.isCollection()) {
                nextScreen = nextScreen.last();
            }
        }
        if (this.isRoot()) {
            this.indexClampLimit();
        }

        

        
        return nextScreen;
    }

    indexIsOutLimits(index) {
        return (index < this.minLimit() || index > this.maxLimit());
    }

    goto(index) {
        this.index = index;
        this.indexClampLimit();
        this.current = this.pages[this.index];
        return this.current;
    }

    next() {
        return this.walk(1);
    }

    prev() {
        return this.walk(-1);
    }

    minLimit() {
        return 0;
    }

    maxLimit() {
        return this.pages.length - 1;
    }

    indexClampLimit() {
        if (this.index >= this.maxLimit())
            this.index = this.maxLimit();
        if (this.index <= this.minLimit())
            this.index = this.minLimit();
    }

    isCollection() {
        return this.model.hasOwnProperty('pages');
    }

    isSimpleScreen() {
        return !this.isCollection();
    }

    inject(property, value) {
        this.element.contentWindow[property] = value;
        return this;
    }

    onready() {
        
        this.element.contentWindow.uid = this.model.uid;
        
        try {

            this.element.contentWindow.onready();
            var acessibilityConfig = this.element.contentWindow.engine_config.config.acessibility;
          
            if (this.element.contentWindow.engine_config.config.behaviors) {
                if(this.element.contentWindow.engine_config.config.behaviors.adaptive){
                    this.behaviorsAdaptive = new BehaviorAdaptative(this.element.contentWindow, this.element.contentWindow.document);
                    this.behaviorsAdaptive.behaviorAdapt(this.element.contentWindow.engine_config.config);
                }
            }


            //MARCA D'AGUA
            if (this.element.contentWindow.engine_config.config.waterMark) {
                //ADICIONANDO MARCA D'AGUA CASO ESTEJA ATIVA NO CONFIG
                this.waterMark = new WaterMark(this.element.contentWindow, this.element.contentWindow.document);
                this.waterMark.addWaterMark();
            }

            //CONTROLE DE FULL SCREEN NO CLIQUE DOS ELEMENTOS COM A CLASSE fullscreen_controll
            var fullscreen_elements = this.element.contentWindow.document.getElementsByClassName("fullscreen_controll");
           

            for(var k=0; k<fullscreen_elements.length;k++){
                bridge.fullScreenControll(fullscreen_elements[k])
            }


            //ATIVANDO OU DESATIVANDO AS FERRAMENTAS DE ACESSIBILIDADE 
            if(acessibilityConfig){
                this.acessibilityDisplayControll = new AcessibilityDisplayControll(this.element.contentWindow, this.element.contentWindow.document, acessibilityConfig);
                this.acessibilityDisplayControll.init();
            }

            //AJUSTANDO O TAMANHO DAS SECTIONS EM ALGUNS NAVEGADORES
            this.fixSize = new FixSize(this.element.contentWindow, this.element.contentWindow.document);
            this.fixSize.init();
            
        } catch (e) {
            console.warn('PAGE[' + this.model.uid + ']', 'não implementou o método onready()', e);
        }
    }

    enterView(direction) {
        try {
            this.element.contentWindow.enterView(direction);
        } catch (e) {
            console.warn('PAGE[' + this.model.uid + ']', 'não implementou o metodo enterView()', e);
        }
    }

    exitView(direction) {
        //COMITANDO OS DADOS PARA O SCORM NO FINAL DE CADA PÁGINA.
        scorm.save();

        try {
            if(this.element.contentWindow!=null){
                this.element.contentWindow.exitView(direction);
            }
            
        } catch (e) {
            console.warn('PAGE[' + this.model.uid + ']', 'não implementou o metodo exitView()', e);
        }
    }
}